<template>
    <div>
        <div class="new-top">
            <el-image
                    style="width: 100%; height:300px"
                    :src="require('../../assets/images/new-bg.jpg')"
                    fit="cover"></el-image>
            <div style="width: 100%;height: 300px;position: absolute;top: 80px;left: 0;z-index: 10;display: flex;align-items: center;justify-content: center;">
                <div>
                    <h2 style="font-size: 40px;">腾宇全球视野</h2>
                    <h3 style="color: #828282;margin-top: 10px;font-size: 16px;">了解更腾宇鸦新闻</h3>
                    <el-autocomplete style="margin-top: 10px;width: 500px;border-radius: 30px"
                                     placeholder="请输入新闻关键词" :trigger-on-focus="false" :fetch-suggestions="querySearch"
                                     @select="handleSelect">
                        <i
                                class="el-icon-search el-input__icon"
                                slot="prefix">
                        </i>
                    </el-autocomplete>
                </div>
            </div>

        </div>
        <div style="width: 100%;height: 40px;"></div>
        <div class="hot-list">
            <div class="hot-list-item" v-for="item in hotList" @click="openDetail(item.newId)">
                <el-image
                        style="width: 100%; height:100%"
                        :src="item.newPics"
                        fit="cover"></el-image>
                <div class="recommend_title__1CK9C">{{item.newTitle}}</div>
            </div>
        </div>
        <div class="tab-list">
            <div :class="'tab-list-item'+(filrer.type==-1?' tab-list-item_active':'')" @click="search(-1)">全部资讯</div>
            <div :class="'tab-list-item'+(filrer.type==0?' tab-list-item_active':'')" @click="search(0)">行业资讯</div>
            <div :class="'tab-list-item'+(filrer.type==1?' tab-list-item_active':'')" @click="search(1)">新闻资讯</div>
            <div :class="'tab-list-item'+(filrer.type==2?' tab-list-item_active':'')" @click="search(2)">企业资讯</div>
            <div :class="'tab-list-item'+(filrer.type==3?' tab-list-item_active':'')" @click="search(3)">高端访谈</div>
            <div :class="'tab-list-item'+(filrer.type==4?' tab-list-item_active':'')" @click="search(4)">经验分享</div>
            <div :class="'tab-list-item'+(filrer.type==5?' tab-list-item_active':'')" @click="search(5)">会展报道</div>
        </div>
        <div class="new-info">
            <div class="new-info_left">
                <div class="new-info_item" v-for="item in list" @click="openDetail(item.newId)">
                    <img :src="item.newPics" style="width: 198px;max-height: 125px;">
                    <div style="flex: 1;position: relative;width: calc(100% - 198px);">
                        <div class="title">{{item.newTitle}}</div>
                        <div class="desc">
                            {{item.newDetail.replace(/[u4e00-u9fa5|,]+/ig,'').replace(/[&\|\/\\\()（）"".*^%$#@」\-]/g,"").replace(/[+]/g,"").replace("微软雅黑","").replace("宋体","")}}
                        </div>
                        <div class="create-time">{{item.createTime}} 浏览量:{{item.num}}</div>
                    </div>
                </div>
                <div style="width: 100%;text-align: right;margin-top: 10px;">
                    <el-pagination
                            @current-change="changCurrent"
                            background
                            layout="prev, pager, next"
                            :total="filrer.total">
                    </el-pagination>
                </div>
            </div>
            <div class="new-info_right">
                <div class="hot-new-info">
                    <h2 class="hotNews_title">热门新闻</h2>
                    <div style="width: 100%;height: 20px;"></div>
                    <div class="hot-new-info_item" v-for="(item,index) in rightList">
                        <div style="width: 40px;display: flex;align-items: flex-start;">
                            <div class="index-style index-one" v-if="index==0">{{index+1}}</div>
                            <div class="index-style index-tow" v-else-if="index==1">{{index+1}}</div>
                            <div class="index-style index-tree" v-else>{{index+1}}</div>
                        </div>
                        <div style="flex: 1;">
                            <div class="new-title" @click="openDetail(item.newId)">{{item.newTitle}}{{item.newTitle}}
                            </div>
                            <div class="hotNews_time">{{item.createTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNewList, getMobileHot} from '../../api/new.js'

    export default {
        data() {
            return {
                restaurants: [],
                hotList: [],
                list: [],
                rightList: [],
                filrer: {
                    type: -1,
                    current: 1,
                    size: 10,
                    total: 0
                }
            }
        },
        created() {
            this.getHotNewList();
            this.search(-1);
            this.getHotList();
        },
        methods: {
            changCurrent(val) {
                this.filrer.current = val;
                this.search(this.filrer.type);
            },
            openDetail(id) {
                this.$router.push({path: '/new/detail', query: {id: id}})
            },
            search(type) {
                this.filrer.type = type;
                getNewList(this.filrer).then(res => {
                    this.list = res.data.records;
                    this.filrer.total = parseInt(res.data.total);
                })
            },
            getHotNewList() {
                getNewList({current: 1, size: 4}).then(res => {
                    this.hotList = res.data.records;
                })
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            handleSelect(item) {
                console.log(item);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.newTitle.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            getHotList() {
                getMobileHot().then(res => {
                    this.rightList = res.data;
                })
            }
            // getRecommendList(){
            // 	getMobileRecommend().then(res=>{

            // 	})
            // }
        }
    }
</script>

<style>

    .new-top {
        width: 100%;
        min-width: 1200px;
        height: auto;
        padding-top: 80px;
        border: 0;
    }

    .hot-list {
        display: flex;
        width: 96%;
        margin-left: 2%;
        min-width: 1200px;
        width: 1200px;
        margin: auto;
    }

    .hot-list-item {
        flex: 1;
        margin-right: 20px;
        position: relative;
        height: 160px;
    }

    .hot-list-item:last-child {
        margin-right: 0;
    }

    .el-input--prefix .el-input__inner {
        padding-left: 30px;
        border-radius: 30px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .recommend_title__1CK9C {
        background: linear-gradient(transparent, #030822);
        bottom: 0;
        height: 97px;
        left: 0;
        position: absolute;
        width: 90%;
        color: #fff;
        text-align: left;
        display: flex;
        align-items: flex-end;
        padding: 20px 5%;
    }

    .tab-list {
        border-bottom: 1px solid #ededed;
        height: 60px;
        margin: 0 auto;
        width: 1200px;
        z-index: 10;
        display: flex;
        align-items: center;
    }

    .tab-list-item {
        width: 100px;
        border-bottom: 2px solid transparent;
        color: #666;
        cursor: pointer;
        font-family: HelveticaNeue-Bold;
        font-size: 14px;
        font-weight: 600;
        height: 60px;
        line-height: 80px;
    }

    .tab-list-item_active {
        border-bottom: 2px solid #ff5800;
        color: #ff5800;
    }

    .new-info {
        display: flex;
        min-width: 1200px;
        width: 1200px;
        margin: auto;

    }

    .new-info_left {
        flex: 1;
    }

    .new-info_right {
        width: 300px;
        text-align: right;
    }

    .new-info_item {
        height: 176px;
        width: 100%;
        position: relative;
        transition: all .2s;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ededed;
        cursor: pointer;
    }

    .new-info_item:hover {
        background-color: #f5f4f5;
    }

    .new-info_item .title {
        color: #282828;
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        letter-spacing: 0;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        width: 650px;
        margin-left: 20px;
    }

    .new-info_item .desc {
        color: #777;
        font-family: HelveticaNeue;
        font-size: 15px;
        line-height: 22px;
        margin: 10px 0;
        width: 650px;
        margin-left: 20px;
        display: block; /*内联对象需加*/
        word-break: keep-all; /* 不换行 */
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis; /*溢出时显示省略标记...；需与overflow:hidden;一起使用*/
    }

    .new-info_item .create-time {
        color: #b8b8b8;
        float: left;
        font-size: 14px;
        line-height: 14px;
        margin-right: 20px;
        margin-left: 20px;
    }

    .hot-new-info {
        width: 94%;
        box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%);
        min-height: 300px;
        margin-left: 6%;
        margin-top: 30px;
    }

    .hot-new-info_item {
        display: flex;
        padding: 10px 0;
        width: 94%;
        margin-left: 3%;
    }

    .hot-new-info_item .index-style {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        width: 20px;
        height: 20px;
        font-size: 12px;
    }

    .index-one {
        background-color: #f84521;
    }

    .index-tow {
        background-color: #ff6f24;
    }

    .index-tree {
        background-color: #ababab;
    }

    .new-title {
        color: #3b3b3b;
        cursor: pointer;
        font-size: 14px;
        line-height: 22px;
        position: relative;
        width: 225px;
        text-align: left;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        max-height: 44px;
    }

    .new-title:hover {
        color: #ff6f24;
    }

    .hotNews_time {
        color: #b8b8b8;
        display: block;
        font-family: HelveticaNeue;
        font-size: 14px;
        line-height: 16px;
        padding-top: 5px;
        text-align: left;
    }

    .hotNews_title {
        width: 94%;
        margin-left: 3%;
        border-bottom: 1px dashed #e6e8eb;
        color: #000;
        font-size: 14px;
        font-weight: 600;
        height: 58px;
        line-height: 58px;
        text-align: center;
    }
</style>